import React, { createContext, useState, useEffect, useContext } from "react";
import { getUserInfo } from "../Api/BarestServices";
import { useHistory, useLocation } from "react-router-dom";
import { errorToast } from "./../Toast/Toast";

const TransferReasonContext = createContext();

export const TransferReasonProvider = ({ children }) => {
  const [userInfoData, setUserInfoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    getUserInfo((succ, res) => {
      if (succ) {
        if (res.status === 1 && res.info.first_name) {
          setUserInfoData(res.info);
          localStorage.setItem("wallet", res.info.wallet);
          setLoading(false);
        } else if (res.status === 0 || res.status === -2) {
          console.warn("کاربر وارد نشده!");
          setLoading(false);
        } else if (
          !res.info.first_name &&
          location.pathname !== "/userinformation"
        ) {
          errorToast("حساب کاربری خود را تکمیل کنید!");
          setTimeout(() => {
            history.push("/userinformation");
          }, 1000);
        }
      } else {
        console.error(res);
        setLoading(false);
      }
    });
  }, [location]);

  return (
    <TransferReasonContext.Provider value={{ userInfoData, loading }}>
      {children}
    </TransferReasonContext.Provider>
  );
};

export const useTransferReasons = () => useContext(TransferReasonContext);
